import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatLayout = createCustomElementWrapper('kat-layout', 'KatLayout', {
    'collapseLeft': 'collapse-left',
    'collapseRight': 'collapse-right',
}, {}, [
    'main',
    'right',
    'left',
]);
